module.exports = __webpack_public_path__ + "img/awesome_default.009685ef.png";